module.exports = __webpack_public_path__ + "static/slide1_img.bd31d852.png";